'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCloseRound = function IoCloseRound(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.2 30.2c1.1 1.1 1.1 2.9 0 4s-2.9 1.1-4 0l-10.2-10.2-10.2 10.2c-1.1 1.1-2.8 1.1-3.9 0s-1.1-2.9 0-4l10.1-10.2-10.1-10.2c-1.1-1.1-1.1-2.9 0-4s2.8-1.1 3.9 0l10.2 10.2 10.2-10.2c1.1-1.1 2.9-1.1 4 0s1.1 2.9 0 4l-10.2 10.2z' })
        )
    );
};

exports.default = IoCloseRound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/close-round.js
// module id = 2022
// module chunks = 0